import { put, call, fork, takeEvery, all } from 'redux-saga/effects';

import * as authModule from '../modules/auth.module';
import * as Api from '../../core/api';

export function* performLogin({ payload: { email, password } }) {
  const { response, error } = yield call(Api.auth.login, { email, password });

  if (response) {
    yield put(authModule.loginSuccess(response));
  } else {
    yield put(authModule.loginFail(error));
  }
}

export function* watchLogin() {
  yield takeEvery(authModule.login.getType(), performLogin);
}

export function* resetPassword({ payload: { password } }) {
  const { response, error } = yield call(Api.auth.resetPassword, password);

  if (response) {
    yield put(authModule.resetPasswordSuccess(response));
  } else {
    yield put(authModule.resetPasswordFail(error));
  }
}

export function* watchResetPassword() {
  yield takeEvery(authModule.resetPassword.getType(), resetPassword);
}

export function* forgotPassword({ payload: { email } }) {
  const { response, error } = yield call(Api.auth.forgotPassword, email);

  if (response) {
    yield put(authModule.forgotPasswordSuccess(response));
  } else {
    yield put(authModule.forgotPasswordFail(error));
  }
}

export function* watchForgotPassword() {
  yield takeEvery(authModule.forgotPassword.getType(), forgotPassword);
}

export default function* watchAuth() {
  return yield all([
    fork(watchLogin),
    fork(watchResetPassword),
    fork(watchForgotPassword),
  ]);
}



/** WEBPACK FOOTER **
 ** ./js/redux/saga/auth.saga.js
 **/